module.exports = __webpack_public_path__ + "sciezka1.png?5906332162f3b67da6c41db6fa3c58c2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sciezka1.png
// module id = 27
// module chunks = 0